<template>
  <section>
    <input
      type="checkbox"
      v-model="isChecked"
      name="isChecked"
      class="custom-checkbox"
    >
  </section>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  name: 'contact-checkbox',
  props: {
    contact: Object
  },
  computed: {
    isChecked: {
      get() {
        return this.contact.isChecked
      },
      set(value) {
        this.setContactChecked({
          contact: this.contact.contact,
          isChecked: value
        })
      }
    }
  },
  methods: {
    ...mapActions('contacts', ['setContactChecked'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/contacts/forms/contact-checkbox.vue